import React from "react";
import IPage from "../../interfaces/page"
import PaymentsComponent from "../../components/Payments/Payments.component";

const PaymentsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <PaymentsComponent></PaymentsComponent>;
};

export default PaymentsPage;
